import React, { useState } from 'react';
import { accountsService } from '@/services/api/api';

const CostCenterCreationDialog = ({ isOpen, onClose, onCostCenterCreated }) => {
  const [formData, setFormData] = useState({
    Code: ''
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    
    try {
      const costCenterData = {
        "Code": formData.Code
      };
      
      const response = await accountsService.createCostCenter(costCenterData);
      const newCostCenter = response.data;
      
      onCostCenterCreated(newCostCenter);
      setFormData({ Code: ''});
      onClose();
    } catch (error) {
      console.error('Error creating cost center:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-3 border-b border-gray-200 pb-3">New Cost Center</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Code<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={formData.Code}
              onChange={(e) => handleInputChange('Code', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
              required
            />
          </div>

                    <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50"
            >
              {loading ? 'Creating...' : 'Create Cost Center'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostCenterCreationDialog;